import Api from './Api.ts';

export const getAllNotifications = async (customOnly?: boolean) => {
  const query = customOnly ? '?customOnly=true' : '';
  return Api.get(`/notifications${query}`);
};

export const sendNotification = async ({ entityType, title, body, entityId }: { entityType: string, title: string, body: string, entityId?: number }) => {
  const payload: any = { entityType, title, body };
  if (entityId) payload.entityId = entityId;
  return Api.post('/notifications/send', payload);
};
